import { useEstimateContext } from '~/legacy/easy-estimator-page/context/estimateContext';

export const useStoreNextButtonVisibility = (): boolean => {
  const { fetchedEstimate } = useEstimateContext();

  return !fetchedEstimate;
};
